exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader {\r\n    font-size: 50px;\r\n    text-align: center;\r\n    color: black;\r\n}\r\n.hidden{\r\n    display: none !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/shared/components/loader/loader.component.css
// module id = ../../../../../src/app/shared/components/loader/loader.component.css
// module chunks = main